import React from 'react';
import {
  TextField as MuiTextField,
  TextFieldProps,
  Box,
  Typography,
  styled,
} from '@mui/material';
import { inputBaseStyles, helperTextStyles, requiredAsteriskStyles } from '../../styles/inputStyles';

interface InputFieldProps extends Omit<TextFieldProps, 'variant'> {
  label?: string;
  helperText?: string;
  width?: string | number;
  optional?: boolean;
}

const StyledTextField = styled(MuiTextField)(() => ({
  ...inputBaseStyles,
  ...requiredAsteriskStyles,
}));

const HelperText = styled(Typography)(() => ({
  ...helperTextStyles,
}));

const TextField: React.FC<InputFieldProps> = ({
  label,
  helperText,
  width,
  optional = false,
  required = false,
  ...props
}) => {
  return (
    <Box>
      {label && (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <Typography component="label" className="input-field-label">
            {label}
            {required && <span>*</span>}
          </Typography>
        </Box>
      )}
      <StyledTextField
        variant="outlined"
        required={required}
        sx={{ width: width || '100%' }}

        {...props}
      />
      {helperText && <HelperText>{helperText}</HelperText>}
    </Box>
  );
};

export default TextField;